import { MbscModule } from '@mobiscroll/angular';
import { environment } from '../environments/environment';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER,  NgModule } from "@angular/core";
// import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

import { AppComponent } from "./app.component";

// Import containers
import { DefaultLayoutComponent } from "./containers";
import { P404Component } from "./views/error/404.component";
import { P500Component } from "./views/error/500.component";
import { LoginComponent } from "./views/login/login.component";
import { RegisterComponent } from "./views/register/register.component";
import { AuthenticationService } from "./views/authentication.service";
import { CompanyService } from "./services/company.service";
import { AuthHeaderService } from "./views/authheader.service";
import { ToastrModule } from "ngx-toastr";
import { CommonModule } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { DxButtonModule, DxCheckBoxModule, DxLoadPanelModule } from "devextreme-angular";
import {
  DxDataGridModule,
  DxBulletModule,
  DxTemplateModule,
  DxDataGridComponent,
} from "devextreme-angular";

const APP_CONTAINERS = [DefaultLayoutComponent];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from "@coreui/angular";

// Import routing module
import { AppRoutingModule } from "./app.routing";

import { StatusFilterPipe } from "./views/loadstatus/statusfilterpipe";

// Import 3rd party components
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
import { NgSelectModule } from "@ng-select/ng-select";
import { ModalModule } from "ngx-bootstrap/modal";
// import { LoadstatusComponent } from "./views/loadstatus/loadstatus.component";
import { EmailValidateComponent } from "./views/email-validate/email-validate.component";
import { ForgotpasswordComponent } from "./views/forgotpassword/forgotpassword.component";
import { ValidateupdatepasswordComponent } from "./views/validateupdatepassword/validateupdatepassword.component";

import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SharedModule } from "./views/shared/shared.module";
import { CompanyregistrationComponent } from './views/companyregistration/companyregistration.component';
import { UnauthorizedComponent } from './views/error/unauthorized/unauthorized.component';
//import { LoadSchedulesComponent } from './views/loadSchedules/load-schedules/load-schedules.component';
// import { CalendarModule } from "angular-calendar";
import { MatStepperModule } from "@angular/material/stepper";
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CompanyEditComponent } from './views/company-edit/company-edit.component';
import { AgmCoreModule } from '@agm/core';
import { TruckCreationPopupComponent } from './views/ratecon-upload/truck-creation-popup/truck-creation-popup.component';
import { DriverCreationPopupComponent } from './views/ratecon-upload/driver-creation-popup/driver-creation-popup.component';
import { CarrierCreationPopupComponent } from './views/ratecon-upload/carrier-creation-popup/carrier-creation-popup.component';
import { LoadsPayPopupComponent } from './views/loads-pay-popup/loads-pay-popup.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LoadsPayPopupDriverPayComponent } from './views/loads-pay-popup-driver-pay/loads-pay-popup-driver-pay.component';
import { LoadsPayPopupDeductionsComponentComponent } from './views/loads-pay-popup-deductions-component/loads-pay-popup-deductions-component.component';
import { LoadsPayPopupPaymentComponentComponent } from './views/loads-pay-popup-payment-component/loads-pay-popup-payment-component.component';
import { LoadsPayPopupCarrierPayComponent } from './views/loads-pay-popup-carrier-pay/loads-pay-popup-carrier-pay.component';
import { PodComponent } from './views/ratecon-upload/pod/pod.component';
import { RateconComponent } from './views/ratecon-upload/ratecon/ratecon.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CompanyJoinRequestComponent } from './views/company-join-request/company-join-request.component';
// import { LoadstatusComponent } from "./views/loadstatus/loadstatus.component";
// import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import {SocketIoModule} from 'ngx-socket-io';
import { TruckTrackerComponent } from './views/truck-tracker/truck-tracker.component'
import {GoogleMapsModule} from '@angular/google-maps';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';



function initializeKeycloak(keycloak: KeycloakService){
  return()=>
  keycloak.init({
    config:
    {
      // url:'http://localhost:8080',
      // realm: 'LoadMiles',
      // clientId:'loadmiles-web'
    // }{
      url:environment.KC_url,
      realm: environment.KC_Realm,
      clientId:environment.KC_client
    },
    initOptions:{
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri:
        window.location.origin + '/assets/silent-check-sso.html'
    },
    bearerExcludedUrls: ['/assets', '/clients/public'],
    shouldUpdateToken(request) {
      return !request.headers.get('token-update') === false;
    }
  }
  )
}


@NgModule({
  imports: [
    MbscModule,
    BrowserModule,
    // DashboardModule,
    SharedModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    FormsModule,
    MatExpansionModule,
    MatSidenavModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    CommonModule,
    NgSelectModule,
    MatMenuModule,
    MatSelectModule,
    DxDataGridModule,
    MatDialogModule,
    DxButtonModule,
    ModalModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgxIntlTelInputModule,
    MatStepperModule,
    DxLoadPanelModule,
    MatAutocompleteModule,
    DxCheckBoxModule,
    MatCheckboxModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleAPIKey,
      libraries: ['places'],
    }),
    KeycloakAngularModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      enableHtml: true,
      newestOnTop: true,
    }),
    SocketIoModule.forRoot(
      {
        url: environment.url,
        options: {
          transports: ['websocket'],
        }
      }
    ),
    GoogleMapsModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    // LoadstatusComponent,
    StatusFilterPipe,
    EmailValidateComponent,
    ForgotpasswordComponent,
    ValidateupdatepasswordComponent,
    CompanyregistrationComponent,
    UnauthorizedComponent,
    ResetPasswordComponent,
    TruckCreationPopupComponent,
    DriverCreationPopupComponent,
    CarrierCreationPopupComponent,
    LoadsPayPopupComponent,
    LoadsPayPopupDriverPayComponent,
    LoadsPayPopupDeductionsComponentComponent,
    LoadsPayPopupPaymentComponentComponent,
    LoadsPayPopupCarrierPayComponent,
    PodComponent,
    RateconComponent,
    CompanyJoinRequestComponent,
    TruckTrackerComponent,
    ],
  providers: [
    AuthenticationService,
    AuthHeaderService,
    CompanyService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi:true,
      deps:[KeycloakService]
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
